import { render, staticRenderFns } from "./TaskExtraCostAssignments.vue?vue&type=template&id=f5c41722&"
import script from "./TaskExtraCostAssignments.vue?vue&type=script&lang=js&"
export * from "./TaskExtraCostAssignments.vue?vue&type=script&lang=js&"
import style0 from "./TaskExtraCostAssignments.vue?vue&type=style&index=0&id=f5c41722&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports